/** @jsx jsx */

import type { WithDataAttributeProp } from '@balance-web/core';
import { getTestIdFromDataAttributes, jsx } from '@balance-web/core';
import { Text } from '@balance-web/text';
import { forwardRefWithAs, makeIdFactory } from '@balance-web/utils';
import { useContext, useMemo } from 'react';

import { FieldContext } from './context';

const FieldDescriptionIdFactory = makeIdFactory('field-description');

type DescriptionProps = WithDataAttributeProp<{
  /** The ID of the element. */
  id?: string;
}>;

export const FieldDescription = forwardRefWithAs<'div', DescriptionProps>(
  (props, ref) => {
    const testids = FieldDescriptionIdFactory();
    const fieldContext = useContext(FieldContext);
    const testid = useMemo(() => {
      const existing = getTestIdFromDataAttributes(props.data);
      if (existing) {
        return existing;
      }

      if (props.id) {
        return testids.base(props.id);
      }

      return testids.base(fieldContext?.id);
    }, []);

    return (
      <Text
        ref={ref}
        color="muted"
        data={{ testid }}
        data-balance-component="field-description"
        size="small"
        {...props}
      />
    );
  }
);
